import { LocalStorage } from "@ng-mw/shared-react-components"
import MenyLocalStorage from "@app/MenyLocalStorage"

export interface GodeKjopNudgeState {
    shownCount: number
    isTooltipVisible: boolean
    shouldOpenKundeavisOnNextClick: boolean
}

interface KundeavisContentLike {
    Title?: string | null
    Link?: string | null
}

// Alias
type Listener = () => void

export const GODE_KJOP_NUDGE_MAX_SHOWS = 3
export const GODE_KJOP_TOOLTIP_BODY = "Visste du at du finner alle ukens tilbud under Gode kjøp?"

const DEFAULT_GODE_KJOP_NUDGE_STATE: GodeKjopNudgeState = {
    shownCount: 0,
    isTooltipVisible: false,
    shouldOpenKundeavisOnNextClick: false,
}

const listeners = new Set<Listener>()

const parseNudgeState = (value: string | null): GodeKjopNudgeState => {
    if (!value) {
        return DEFAULT_GODE_KJOP_NUDGE_STATE
    }

    try {
        return JSON.parse(value) as GodeKjopNudgeState
    } catch {
        return DEFAULT_GODE_KJOP_NUDGE_STATE
    }
}

let godeKjopNudgeState = parseNudgeState(LocalStorage.get(MenyLocalStorage.GodeKjopNudge))

const notifyListeners = () => {
    listeners.forEach(listener => listener())
}

const writeGodeKjopNudgeState = (state: GodeKjopNudgeState): void => {
    godeKjopNudgeState = state
    LocalStorage.set(MenyLocalStorage.GodeKjopNudge, JSON.stringify(state))
    notifyListeners()
}

export const subscribeToGodeKjopNudge = (listener: Listener): (() => void) => {
    listeners.add(listener)

    return () => {
        listeners.delete(listener)
    }
}

export const getGodeKjopNudgeState = (): GodeKjopNudgeState => godeKjopNudgeState

export const isKundeavisContentBlock = (content: KundeavisContentLike): boolean => {
    const title = (content.Title ?? "").trim().toLowerCase()
    const link = (content.Link ?? "").trim().toLowerCase()

    return (title === "kundeavis" || link.includes("kundeavis")) && Boolean(content.Link)
}

export const shouldOpenKundeavis = (state: GodeKjopNudgeState): boolean =>
    state.shouldOpenKundeavisOnNextClick || state.shownCount >= GODE_KJOP_NUDGE_MAX_SHOWS

export const registerKundeavisClickForNudge = (): void => {
    if (shouldOpenKundeavis(godeKjopNudgeState)) {
        writeGodeKjopNudgeState({
            ...godeKjopNudgeState,
            isTooltipVisible: false,
            shouldOpenKundeavisOnNextClick: false,
        })
        return
    }

    writeGodeKjopNudgeState({
        shownCount: godeKjopNudgeState.shownCount + 1,
        isTooltipVisible: true,
        shouldOpenKundeavisOnNextClick: true,
    })
}

export const dismissGodeKjopTooltip = (): void => {
    if (!godeKjopNudgeState.isTooltipVisible) {
        return
    }

    writeGodeKjopNudgeState({
        ...godeKjopNudgeState,
        isTooltipVisible: false,
    })
}
